<div id="SketchComponent" [class.disabled]="isDisabled" #createElementRef>
  <div class="row">
    <div class="col-md-12">
      <select
        class="select-edit-toolbox pull-left"
        [(ngModel)]="selectedLayer"
        [disabled]="activated"
        (change)="onLayerChange($event)"
      >
        <option
          *ngFor="let layer of editableLayers"
          [ngValue]="layer"
          [selected]="layer === selectedLayer"
        >
          {{ layer.title ?? layer.id }}
        </option>
      </select>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-12 sketch">
    <div #sketchRef></div>
  </div>
</div>
